define('shared/remote/country/state/Entity',[
    './city/Entity'
],
function (CityEntity) {
    'use strict';

    function initializeCities(cqJson) {
        var cities = [];

        if (!cqJson.cities) {
            return cities;
        }

        for (var key in cqJson.cities) {
            if (
                cqJson.cities.hasOwnProperty(key) === false ||
                key.indexOf('jcr:') === 0 ||
                key.indexOf('cq:') === 0
            ) {
                continue;
            }

            cities.push(new CityEntity(this._marketCode, this._code, cqJson.cities[key]));
        }

        return cities;
    }


    function Ctor(marketCode, cqJson) {
        this._marketCode = marketCode;
        this._data = cqJson;
        this._code = cqJson.code;
        this._name = cqJson.name;
        this._phones = {};

        if (cqJson.mobile) {
            this._phones.mobile = {
                prefix: typeof cqJson.mobile === 'string' ? [cqJson.mobile] : cqJson.mobile
            };
        }

        if (cqJson.landline) {
            this._phones.landline = {
                prefix: typeof cqJson.landline === 'string' ? [cqJson.landline] : cqJson.landline
            };
        }

        this._cities = initializeCities.call(this, cqJson);
    }

    var p = Ctor.prototype;

    p.marketCode = function () {
        return this._marketCode;
    };

    p.code = function () {
        return this._code;
    };

    p.name = function () {
        return this._name;
    };

    p.phones = function () {
        return this._phones;
    };

    p.cities = function () {
        return this._cities;
    };

    return Ctor;
});
